<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>Usuários do Sistema</b>
						</h3>
						<router-link tag="a" class="btn btn-primary pull-right" to="/administracao/usuarios/novo">Novo</router-link>
					</div>
					<div class="box-body">
						<div class="row">
							<div class="col-md-12">
								<input style="width: 100%" class="form-control" placeholder="Busca: Entre com o nome do usuário" name="filtro_pesquisa" ref="filtro_pesquisa" type="text" v-model="dados.filtro" @keyup.enter="getDataTable">
							</div>
						</div>
						<div class="row" style="margin-top:15px">
							<div class="col-sm-12 table-responsive">
								<table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
									<thead>
										<tr role="row">
											<th style="width: 35%">Nome</th>
											<th style="width: 20%">Login</th>
                      <th style="width: 13%">Nível</th>
                      <th style="width: 20%">Empresa</th>
											<th style="width: 12%">Ação</th>
										</tr>
									</thead>
									<tbody>
										<tr class="even" role="row" v-for="item in apiData.data" :key="item.id">
											<td>{{ item.name }}</td>
											<td>{{ item.login }}</td>
                      <td>{{ item.nivel | nivel }}</td>
											<td>{{ item.empresa.fantasia }}</td>
											<td>
													<router-link class="btn btn-warning btn-sm" tag="button" :to="'/administracao/usuarios/atualizacao/'+ item.id" title="Atualizar">
												<i class="fa fa-fw fa-edit"></i>
											</router-link>
											<button class="btn btn-danger btn-sm" title="Bloquear">
												<i class="fa fa-fw fa-lock"></i>
											</button>
											</td>
										</tr>
									</tbody>
								</table>
								<div class="row">
									<div class='col-sm-5'>
										Mostrando {{ this.apiData.from }} até {{ this.apiData.to }} de {{ this.apiData.total }} registros encontrados.
									</div>
									<div class='col-sm-7' style="text-align:right">
										<laravue-pagination :limit="5" :data="apiData" v-on:pagination-change-page="getDataTable">
											<span slot="prev-nav">&lt; Anterior</span>
											<span slot="next-nav">Próximo &gt;</span>
										</laravue-pagination>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- /.box-body -->
				</div>
				<!-- /.box -->
			</div>
			<!-- /.col-md-12 -->
		</div>
		<!-- /.row -->
	</section>
</template>
<script>
import axios from 'axios' // Cliente para requisição http

export default {
	data: () => ({
		dados: {
			filtro: '',
		},
    apiData: {
      data: [],
    },
	}),
	mounted () {
		this.getDataTable();
		this.$nextTick(() => { this.$refs.filtro_pesquisa.focus() });
	},

	methods: {
		getDataTable (page) {
			if (typeof page === 'undefined') {
				page = 1;
			}
			this.dados.page = page;
			this.$store.commit('TOGGLE_LOADING');
			let config = this.$store.getters.getHeaderAuth;
			config.params = this.dados;
			axios.get(`${this.$store.state.serverURI}/api/usuario/getAllPaginate`, config)
				.then(response => {
					this.apiData = response.data;
					this.$store.commit('TOGGLE_LOADING');
				}).catch((error) => { this.$store.commit('throwException', error); });

		},

	},
	watch: {
		page: function (val) {
			this.getDataTable();
		}
	},

	components: {

	}

}
</script>
<style>
</style>



// WEBPACK FOOTER //
// index.vue?1b8cd92e